import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class AddUpdatePackageResData extends ServiceResponseData {
    packages: Map<number, string>;
    signatureErrors: Array<string>;
    alreadyExists: Array<string>;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Packages) {
            this.packages = new Map<number, string>();
            Object.entries(obj.Packages).forEach((pair: any) => {
                this.packages.set(pair[0], pair[1]);
            });
        }
        if (obj.SignatureErrors && obj.SignatureErrors.length) {
            this.signatureErrors = new Array<string>();
            obj.SignatureErrors.forEach((error) => {
                this.signatureErrors.push(error);
            });
        }
        if (obj.AlreadyExists && obj.AlreadyExists.length) {
            this.alreadyExists = new Array<string>();
            obj.AlreadyExists.forEach((error) => {
                this.alreadyExists.push(error);
            });
        }
    }
}
